import React from 'react';

const errorMessageMap = {
  serviceError: {
    title: 'Ha ocurrido un error',
    content: 'No se ha podido completar tu solicitud, vuelve a intentarlo',
  },
  noRecharge: {
    title: '¡Lo sentimos!',
    getContent: (hasDebt, hasRecharged) => (
      <>
        No es posible pedir un extra saldo porque
        {!hasDebt && !hasRecharged && (
          <>
            {' '}
            no has realizado una recarga durante los{' '}
            <strong>últimos 30 días</strong>
          </>
        )}
        {hasDebt && hasRecharged && (
          <>
            {' '}
            <strong>tienes una deuda pendiente</strong>
          </>
        )}
        {hasDebt && !hasRecharged && (
          <>
            {' '}
            no has realizado una recarga durante los{' '}
            <strong>últimos 30 días</strong> y además{' '}
            <strong>tienes una deuda pendiente</strong>
          </>
        )}
      </>
    ),
  },
};

const getErrorMessage = (hasDebt, hasRecharged, serviceError) => {
  const key = serviceError ? 'serviceError' : 'noRecharge';

  return {
    title: errorMessageMap[key].title,
    content: serviceError
      ? errorMessageMap[key].content
      : errorMessageMap[key].getContent(hasDebt, hasRecharged),
  };
};

export default getErrorMessage;
